<template>

<div v-if="!show" class="ui active loader"></div>
<main>
  <div class="ui stackable center one column divided grid" id="tracking">
    <div class="row" id="apm" v-if="parcel">
      <div class="field ubication">
        <img class="ui image" src="../assets/ubication.jpg">
        {{ parcel.apm }}
      </div>
    </div>

    <div v-if="parcel" class="row">
        <div v-if="parcel.status=='new'" class="ui gray message"> 
          <div class="ui relaxed divided list">
            <p> Estamos esperando a que tu envío sea introducido en el armario.</p>
            <p> Cuando se introduzca recibirás un SMS con el código de apertura para recogerlo. </p>
          </div>
        </div>

        <div v-if="parcel.status=='in-apt'" class="ui gray message"> 
          <div class="ui relaxed divided list">
            <p v-if="sendSmsOk"> El envío está en el armario. </p>
            <p v-if="sendSmsOk"> Te hemos enviado un SMS con el código de apertura. Revisa tu móvil. </p>

            <p v-if="!sendSmsOk"> El envío esta en el armario, pero vemos que no has recibido el SMS. </p>
            <p v-if="!sendSmsOk"> Por favor, ponte en contacto con nosotros a través del teléfono 943 177 199 o el email info@hapiick.com</p>
          </div>
        </div>

        <div v-if="parcel.status=='delivered'" class="ui gray message"> 
          <div class="ui relaxed divided list">
            <p> El envío ya ha sido recogido. </p>
          </div>
        </div>

        <div v-if="parcel.status=='to-term'" class="ui gray message"> 
          <div class="ui relaxed divided list">
            <p> El envío ha sido retirado por el mensajero. </p>
            <p> Ponte en contacto con la agencia de transportes o con la tienda donde has hecho el pedido. </p>
          </div>
        </div>
    </div>
    <div v-if="codError" class="row" style="margin-top:25px">
        <div class="ui error message"> 
          <div class="ui relaxed divided list">
            <p> Ha habido algún problema a la hora obtener los datos de tu envío. </p>
            <p> Por favor, ponte en contacto con nosotros a través del teléfono 943 177 199 o el email info@hapiick.com </p>
          </div>
        </div>
    </div>
  </div>

<!--
  stackable >> sirve para que cuando se visualice en el móvil, lo que ahora se ve en dos columnas lo ponga solamente en 1 unica columna
 --> 
  <div class="ui stackable center two column divided grid" id="tracking">
    <div class="row">
      <div v-if="parcel" class="column">
        <!-- <h4 class="ui dividing header">Tracking</h4> -->
        <div class="ui segment"> <!-- ui segment le pone como un borde a la img-->
          <img class="ui medium image" :src="require('../assets/' + imgTracking + '.png')">
        </div>
      </div>
 
      <div v-if="codError" class="column">
        <!-- <h4 class="ui dividing header">Tracking</h4> -->
        <div class="ui segment"> <!-- ui segment le pone como un borde a la img-->
          <img class="ui medium image" src="../assets/notfound.png">
        </div>
      </div>

      <div v-if="parcel" class="column">
        <!-- <h4 class="ui dividing header">Info</h4> -->
        <div v-if="apt.address" class="form ui">
          <div class="field">
            <label>Ubicación del armario
            <input type="text" v-model="apt.address" readonly></label>
          </div>

          <div v-if="parcel.status=='new'" class="field">
            <label>Fecha de pedido
            <input type="text" v-model="parcel.created" readonly></label>
          </div>

          <div v-if="parcel.status=='in-apt'" class="field">
            <label>Fecha de introducción del envio en el armario
            <input type="text" v-model="parcel.in_apt_date" readonly></label>
          </div>

          <div v-if="smsList" class="field">
            <label>Fecha de envio del SMS
            <input type="text" v-model="smsList.modified" readonly></label>
          </div>

          <div v-if="parcel.status=='to-term' || parcel.status=='delivered'" class="field">
            <label v-if="parcel.status=='to-term'">
              Fecha de retirada por el mensajero <input type="text" v-model="parcel.lastUpdate" readonly>
            </label>
            <label v-if="parcel.status=='delivered'">
              Fecha de recogida por el cliente <input type="text" v-model="parcel.lastUpdate" readonly>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="smslist" class="ui stackable one column divided grid">
    <div class="row">
      <div class="column" id="sms_id">
        <h4 class="ui dividing header">Notificaciones</h4>
        <div class="ui relaxed divided list">
         <div class="item" v-for="sms in smslist" :key="sms.id">
            <img class="ui mini image" src="../assets/sms.png">
            <div class="content">
              <span class="header"> {{ sms.SmsStatus.modified }} </span>
              <div class="description">
                <b>{{ sms.SmsStatus.from_name }}</b>
<!--                 <b>{{ sms.SmsStatus.from_name }}: </b> 
                <span class="txiki">{{ sms.SmsStatus.text }}</span> -->
              </div>
            </div>
            <div class="right floated content">
              <!-- <span class="header">{{ sms.SmsStatus.to_phone.substr(-4).padStart(9, '*') }}</span> -->
              <span class="header" id="idPhone">{{ sms.SmsStatus.to_phone }}</span>
              <div class="description" id="idStatus">{{ sms.SmsStatus.status }}</div>
            </div>
          </div>
        </div>
        <!-- <div v-if="data.status=='in-apt'" class="ui button green" v-on:click="resendSms(data.parcel_id,data.phone)">Re-enviar</div> -->
      </div>
    </div>
  </div>
</main>
</template>

<script>
export default {
  name: 'Tracking',
  props: ['barcode'],
  data() {
    return {
      show: false,
      imgTracking: null,
      parcel: false,
      smsList: false,
      apt: false,
      codError: false,
      sendSmsOk: false
    }
  },
  created() {
    if(this.barcode.length > 0) {
      this.tracking(this.barcode);
    }
  },
  methods: {
    tracking(barcode) {
      let url = this.$url_hapiick + "/v1/tracking?barcode="+barcode;

      let headers = {
        'Content-Type': 'application/json',
      }
      if (this.$subscription !== '') {
        headers['Ocp-Apim-Subscription-Key'] = this.$subscription
      }

      this.axios.get(url,{
        headers: headers
      })
      .then(request => {
        this.show = true;

        if (request.data.error) {
          this.codError = request.data.error;
        }

        if (!this.codError) {
          if (request.data.result.parcel) {
            if (request.data.result.parcel.length > 0) {
              this.parcel = request.data.result.parcel[0];
              this.imgTracking = this.parcel.status;
            } else {
              this.codError = true;
            }
          }

          if (request.data.result.apt) {
            this.apt = request.data.result.apt;
          }

          if (request.data.result.smslist) {
            if (request.data.result.smslist.length > 0) {
              this.smslist = request.data.result.smslist;
              this.checkSMSStatus(this.smslist);
            }
          }
        }
      })
      .catch((error) => {
        this.catchErrors(error);
      })
    },
    checkSMSStatus(sms){
      let aux = sms.map((a) => {
          return a.SmsStatus.status
        })

        if (aux.includes("DELIVERED")) {
          this.sendSmsOk = true;
        }
    },
    catchErrors(error){
      if(error.request) {
        console.log(error.request)
      }
    },
  }
}
</script>

<style scoped>
main {
  width: 95%;
  margin: auto;
}

label {
  width: 100%;
}

#apm {
  padding: 5px 0px 5px 0px!important;
}

#sms_id {
  padding-top: 10px!important;
}

#idPhone, #idStatus {
  text-align: end!important;
}

.grid {
  margin: 0px!important;
}


.field {
  align-items: center;
  display: flex;
}

.ubication {
  font-size: 20px;
}

.ubication img {
  width: 55px;
}

.message {
  width: 100%;
}

input {
  border: none!important;
  border-bottom: 1px solid darkgray!important;
  width: 20%
}
</style>
